module.exports = __webpack_public_path__ + "img/blk_01.b9eec441.png";